import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../context/SiteSettingsContext';

const Logo = ({ image, image2, companyName, showName }) => {
    const settings = useSiteSettings();
    const usingCustomSettings = image === undefined && image2 === undefined;

    const logoForDarkTheme = image || settings.headerLogoUrl;
    const logoForLightTheme = image2 || settings.headerLogoLightUrl || logoForDarkTheme;
    const brandName = companyName !== undefined ? companyName : settings.company_name;
    const shouldShowName = showName !== undefined ? showName : settings.show_company_name;

    if (usingCustomSettings && !settings.ready) {
        return (
            <div className="logo">
                <Link to={`${process.env.PUBLIC_URL}/`} className="site-brand-link site-brand-link--loading" aria-label="Loading">
                    <span className="site-brand-logo-placeholder" aria-hidden="true" />
                </Link>
            </div>
        );
    }

    return (
        <div className="logo">
            <Link to={`${process.env.PUBLIC_URL}/`} className="site-brand-link">
                {logoForDarkTheme ? (
                    <img
                        className="logo-light site-brand-logo"
                        src={logoForDarkTheme}
                        alt={brandName || 'Home'}
                        decoding="async"
                    />
                ) : null}
                {logoForLightTheme ? (
                    <img
                        className="logo-dark site-brand-logo"
                        src={logoForLightTheme}
                        alt={brandName || 'Home'}
                        decoding="async"
                    />
                ) : null}
                {shouldShowName && brandName ? (
                    <span className="site-brand-name">{brandName}</span>
                ) : null}
            </Link>
        </div>
    );
};

Logo.propTypes = {
    image: PropTypes.string,
    image2: PropTypes.string,
    companyName: PropTypes.string,
    showName: PropTypes.bool,
};

export default Logo;
